// extracted by mini-css-extract-plugin
export default {"add_wrap":"aiSettings_add_wrap__QNHWP","add_btn":"aiSettings_add_btn__DdVjN","number_badge_wrap":"aiSettings_number_badge_wrap__98P6r","badge":"aiSettings_badge__NCXRe"};